/* ============================================================
   FamilyFirst – Vélemény kérdőív (popup + banner + rendelés utáni)
   Egy fájl, nulla függőség. Shadow DOM-ban fut, így a webshop
   CSS-e és a script CSS-e nem ütközik egymással.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- 1. BEÁLLÍTÁSOK ------------------------------- */
  var DEFAULTS = {
    // Mikor jöjjön fel a popup
    popupDelayMs: 20000,      // belépés után 20 mp
    exitIntent: true,         // egérrel kifelé mozdulásra (csak desktop)
    mobileScrollPercent: 55,  // mobilon ennyi % görgetés után
    showBanner: true,         // alsó diszkrét sáv

    // Milyen oldalakon NE jelenjen meg
    excludePaths: ['/cart', '/checkout', '/account'],

    // Rendelés utáni (köszönőoldali) megjelenés
    thankYouPaths: ['/thank_you', '/orders/', '/pages/koszonjuk'],
    inlineTarget: '#ff-survey-inline', // ide rendereli, ha létezik

    // Ismétlődés korlátozása
    dismissDays: 30,          // ha bezárta, ennyi napig nem kérdezünk újra
    completeDays: 180,        // ha kitöltötte, ennyi napig nem kérdezünk újra

    // Jutalom
    coupon: {
      enabled: true,
      code: 'THANKYOU10',
      label: '10% kedvezmény a következő rendelésedhez',
      validDays: 30
    },

    // Adatküldés. null = csak dataLayer esemény megy (GA4/GTM).
    // Google Apps Script webhook URL vagy saját API végpont.
    endpoint: null,
    endpointMode: 'no-cors', // saját API-nál, ha van CORS fejléc: 'cors'

    // E-mail bekérés a végén (GDPR: külön hozzájárulás!)
    askEmail: true,
    privacyUrl: '/policies/privacy-policy',

    // Popup illusztráció. null = a beépített SVG ajándék-illusztráció.
    // Saját fotóhoz add meg a kép URL-jét, pl. '/cdn/shop/files/csalad.jpg'
    heroImage: null,
    heroAlt: 'Ajándék kupon a kérdőív kitöltéséért'
  };

  var CFG = Object.assign({}, DEFAULTS, window.FF_SURVEY_CONFIG || {});
  if (window.FF_SURVEY_CONFIG && window.FF_SURVEY_CONFIG.coupon) {
    CFG.coupon = Object.assign({}, DEFAULTS.coupon, window.FF_SURVEY_CONFIG.coupon);
  }

  /* ---------- 2. KÉRDÉSEK ---------------------------------- */
  var QUESTIONS = [
    {
      id: 'satisfaction',
      type: 'scale',
      title: 'Mennyire vagy elégedett a FamilyFirst webáruházzal?',
      min: 1, max: 6,
      minLabel: 'Egyáltalán nem',
      maxLabel: 'Teljesen'
    },
    {
      id: 'ease',
      type: 'choice',
      title: 'Mennyire volt egyszerű a vásárlás folyamata?',
      options: ['Nagyon nehéz', 'Nehéz', 'Közepes', 'Könnyű', 'Nagyon könnyű']
    },
    {
      id: 'improve',
      type: 'multi',
      title: 'Mely területen tudnánk még jobbak lenni?',
      hint: 'Több válasz is jelölhető',
      options: ['Termékválaszték', 'Árak', 'Szállítás', 'Ügyfélszolgálat', 'Weboldal használhatósága', 'Egyéb']
    },
    {
      id: 'nps',
      type: 'nps',
      title: 'Mennyire valószínű, hogy ajánlanád a FamilyFirst-öt másoknak?',
      minLabel: 'Egyáltalán nem',
      maxLabel: 'Nagyon valószínű'
    },
    {
      id: 'comment',
      type: 'text',
      title: 'Van még valamilyen észrevételed?',
      hint: 'Nem kötelező',
      placeholder: 'Írd ide a válaszod…',
      optional: true
    }
  ];

  /* ---------- 3. TÁROLÁS (localStorage + memória fallback) --- */
  var store = (function () {
    try {
      localStorage.setItem('__ff_t', '1');
      localStorage.removeItem('__ff_t');
      return localStorage;
    } catch (e) {
      var mem = {};
      return {
        getItem: function (k) { return k in mem ? mem[k] : null; },
        setItem: function (k, v) { mem[k] = String(v); },
        removeItem: function (k) { delete mem[k]; }
      };
    }
  })();

  function setFlag(key, days) {
    store.setItem('ff_survey_' + key, String(Date.now() + days * 864e5));
  }
  function flagActive(key) {
    var v = store.getItem('ff_survey_' + key);
    return !!v && Number(v) > Date.now();
  }

  /* ---------- 4. ESEMÉNYEK (GA4 / GTM) ---------------------- */
  window.dataLayer = window.dataLayer || [];
  function track(name, params) {
    var payload = Object.assign({ event: name, survey_id: 'ff_csat_v1' }, params || {});
    window.dataLayer.push(payload);
    if (typeof window.gtag === 'function') window.gtag('event', name, payload);
  }

  /* ---------- 4b. ILLUSZTRÁCIÓ ------------------------------ */
  var HERO_SVG = `
  <svg class="art" viewBox="0 0 220 132" role="img" aria-label="Ajándék kuponcsomag">
    <g class="art-sparkle">
      <path d="M36 22 l2.4 6.6 6.6 2.4 -6.6 2.4 -2.4 6.6 -2.4 -6.6 -6.6 -2.4 6.6 -2.4z" fill="#F2A03D"/>
      <path d="M186 34 l1.8 5 5 1.8 -5 1.8 -1.8 5 -1.8 -5 -5 -1.8 5 -1.8z" fill="#14631B" opacity=".35"/>
      <path d="M28 92 l1.5 4.2 4.2 1.5 -4.2 1.5 -1.5 4.2 -1.5 -4.2 -4.2 -1.5 4.2 -1.5z" fill="#F2A03D" opacity=".7"/>
    </g>

    <ellipse cx="100" cy="119" rx="52" ry="7" fill="#14631B" opacity=".13"/>

    <!-- doboz teste -->
    <rect x="66" y="62" width="68" height="52" rx="7" fill="#1B7A24"/>
    <rect x="66" y="62" width="68" height="52" rx="7" fill="url(#ffShade)"/>
    <!-- masni szalag függőlegesen -->
    <rect x="92" y="62" width="16" height="52" fill="#F2A03D"/>
    <!-- fedél -->
    <rect x="56" y="44" width="88" height="22" rx="7" fill="#14631B"/>
    <rect x="92" y="44" width="16" height="22" fill="#F2A03D"/>
    <!-- masni -->
    <g class="art-bow">
      <ellipse cx="85" cy="36" rx="14" ry="9.5" fill="#F2A03D" transform="rotate(-24 85 36)"/>
      <ellipse cx="115" cy="36" rx="14" ry="9.5" fill="#F2A03D" transform="rotate(24 115 36)"/>
      <ellipse cx="85" cy="36" rx="6" ry="4" fill="#D98526" transform="rotate(-24 85 36)"/>
      <ellipse cx="115" cy="36" rx="6" ry="4" fill="#D98526" transform="rotate(24 115 36)"/>
      <circle cx="100" cy="41" r="7" fill="#F2A03D"/>
    </g>

    <!-- kedvezmény címke -->
    <g class="art-tag" transform="rotate(-11 172 78)">
      <rect x="141" y="60" width="62" height="36" rx="10" fill="#fff" stroke="#F2A03D" stroke-width="2.5"/>
      <text x="172" y="84" text-anchor="middle" font-size="21" font-weight="800"
            fill="#14631B" font-family="Segoe UI, Arial, sans-serif">-10%</text>
    </g>

    <defs>
      <linearGradient id="ffShade" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#fff" stop-opacity=".12"/>
        <stop offset="1" stop-color="#000" stop-opacity=".1"/>
      </linearGradient>
    </defs>
  </svg>`;

  function heroHtml() {
    var inner = CFG.heroImage
      ? '<img src="' + CFG.heroImage + '" alt="' + CFG.heroAlt + '" class="photo">'
      : HERO_SVG;
    return '<div class="hero">' + inner + '</div>';
  }

  /* ---------- 5. STÍLUS ------------------------------------- */
  var CSS = `
  :host { all: initial; }
  * { box-sizing: border-box; margin: 0; padding: 0;
      font-family: inherit, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; }

  :host {
    --green: #14631B;
    --green-dark: #0E4A14;
    --green-soft: #E9F3EA;
    --blue: #C7E4F7;
    --blue-soft: #EAF5FD;
    --ink: #0F2A14;
    --muted: #5B7360;
    --line: #DCE7DD;
    --orange: #F2A03D;
    --r: 16px;
    font-size: 16px;
    line-height: 1.45;
    color: var(--ink);
  }

  .overlay {
    position: fixed; inset: 0; z-index: 2147483000;
    background: rgba(10, 40, 15, .45);
    display: flex; align-items: center; justify-content: center;
    padding: 20px;
    animation: fade .2s ease;
  }
  @keyframes fade { from { opacity: 0 } to { opacity: 1 } }
  @keyframes rise { from { opacity: 0; transform: translateY(14px) } to { opacity: 1; transform: none } }

  .card {
    position: relative;
    width: 100%; max-width: 460px;
    max-height: 92vh; overflow-y: auto;
    background: #fff; border-radius: var(--r);
    box-shadow: 0 24px 60px rgba(10, 40, 15, .3);
    animation: rise .25s ease;
  }
  .card--inline {
    box-shadow: 0 2px 14px rgba(10,40,15,.08);
    border: 1px solid var(--line);
    max-width: 560px; margin: 0 auto; animation: none; max-height: none;
  }

  .hero {
    background: var(--blue-soft);
    border-radius: var(--r) var(--r) 0 0;
    padding: 14px 20px 6px;
    display: flex; justify-content: center;
    overflow: hidden;
  }
  .hero .art { width: 100%; max-width: 230px; height: auto; display: block; }
  .hero .photo { width: 100%; max-height: 158px; object-fit: cover; border-radius: 12px; }
  .hero + .head { border-radius: 0; }

  .art-bow { transform-origin: 100px 40px; animation: bow .7s ease .15s both; }
  .art-tag { animation: tag 2.6s ease-in-out .8s infinite; transform-origin: 172px 78px; }
  .art-sparkle path { animation: twinkle 2.2s ease-in-out infinite; }
  .art-sparkle path:nth-child(2) { animation-delay: .5s; }
  .art-sparkle path:nth-child(3) { animation-delay: 1s; }
  @keyframes bow { from { transform: scale(.4) translateY(12px); opacity: 0 } to { transform: none; opacity: 1 } }
  @keyframes tag { 0%,100% { transform: rotate(-11deg) } 50% { transform: rotate(-4deg) } }
  @keyframes twinkle { 0%,100% { opacity: .3 } 50% { opacity: 1 } }

  .head {
    background: var(--green); color: #fff;
    padding: 20px 22px 16px; border-radius: var(--r) var(--r) 0 0;
  }
  .head h2 { font-size: 21px; font-weight: 800; letter-spacing: -.01em; }
  .head p { font-size: 14px; opacity: .88; margin-top: 5px; }

  .bar { height: 5px; background: rgba(255,255,255,.28); border-radius: 99px; margin-top: 14px; overflow: hidden; }
  .bar i { display: block; height: 100%; background: #fff; border-radius: 99px; transition: width .3s ease; }
  .meta { display: flex; justify-content: space-between; font-size: 12px; opacity: .85; margin-top: 7px; }

  .body { padding: 22px; }
  .q { font-size: 17px; font-weight: 700; margin-bottom: 4px; }
  .hint { font-size: 13px; color: var(--muted); margin-bottom: 14px; }
  .q + .opts, .q + .scale, .q + .field { margin-top: 16px; }

  .scale { display: flex; gap: 7px; }
  .scale button {
    flex: 1; aspect-ratio: 1/1; min-width: 0;
    border: 1.5px solid var(--line); background: #fff; border-radius: 11px;
    font-size: 16px; font-weight: 700; color: var(--ink); cursor: pointer;
    transition: .12s;
  }
  .nps .scale button { aspect-ratio: auto; padding: 11px 0; font-size: 14px; border-radius: 9px; }
  .scale button:hover { border-color: var(--green); background: var(--green-soft); }
  .scale button[aria-pressed="true"] { background: var(--green); border-color: var(--green); color: #fff; }
  .ends { display: flex; justify-content: space-between; font-size: 12px; color: var(--muted); margin-top: 8px; }

  .opts { display: flex; flex-direction: column; gap: 9px; }
  .opts button {
    text-align: left; padding: 13px 15px; font-size: 15px;
    border: 1.5px solid var(--line); background: #fff; border-radius: 11px;
    color: var(--ink); cursor: pointer; transition: .12s;
  }
  .opts button:hover { border-color: var(--green); background: var(--green-soft); }
  .opts button[aria-pressed="true"] { border-color: var(--green); background: var(--green-soft); font-weight: 650; }
  .opts button[aria-pressed="true"]::before { content: "✓ "; color: var(--green); font-weight: 800; }

  .field textarea, .field input {
    width: 100%; padding: 12px 14px; font-size: 15px; color: var(--ink);
    border: 1.5px solid var(--line); border-radius: 11px; background: #fff; resize: vertical;
  }
  .field textarea { min-height: 92px; }
  .field textarea:focus, .field input:focus { outline: 2px solid var(--green); outline-offset: 1px; border-color: var(--green); }
  .label { font-size: 13px; font-weight: 650; margin-bottom: 6px; display: block; }

  .consent { display: flex; gap: 9px; align-items: flex-start; margin-top: 13px; font-size: 12.5px; color: var(--muted); }
  .consent input { margin-top: 2px; width: 17px; height: 17px; accent-color: var(--green); flex: none; }
  .consent a { color: var(--green); }

  .actions { display: flex; gap: 10px; align-items: center; margin-top: 18px; }
  .btn {
    flex: 1; padding: 13px 18px; font-size: 15px; font-weight: 700;
    background: var(--green); color: #fff; border: 0; border-radius: 11px; cursor: pointer;
  }
  .btn:hover { background: var(--green-dark); }
  .btn:disabled { opacity: .4; cursor: not-allowed; }
  .btn--ghost { flex: none; background: none; color: var(--muted); font-weight: 550; padding: 13px 4px; }
  .btn--ghost:hover { background: none; color: var(--ink); text-decoration: underline; }

  .close {
    position: absolute; top: 13px; right: 13px; width: 32px; height: 32px;
    border: 0; border-radius: 50%; background: rgba(255,255,255,.2); color: #fff;
    font-size: 19px; line-height: 1; cursor: pointer;
  }
  .close:hover { background: rgba(255,255,255,.35); }

  /* Köszönő / kupon képernyő */
  .done { text-align: center; padding: 30px 24px 26px; }
  .done .ico { font-size: 40px; }
  .done h3 { font-size: 20px; font-weight: 800; margin: 10px 0 6px; }
  .done p { font-size: 14.5px; color: var(--muted); }
  .coupon {
    margin: 18px 0 6px; padding: 16px; border: 2px dashed var(--orange);
    background: #FFF8EE; border-radius: 13px;
  }
  .coupon .lab { font-size: 12.5px; color: var(--muted); }
  .coupon .code { font-size: 25px; font-weight: 850; letter-spacing: .1em; color: var(--green); margin: 5px 0 3px; }
  .coupon .val { font-size: 12px; color: var(--muted); }
  .copy { margin-top: 11px; padding: 10px 16px; font-size: 14px; font-weight: 700;
          background: var(--green); color: #fff; border: 0; border-radius: 10px; cursor: pointer; }

  /* Alsó sáv */
  .banner {
    position: fixed; left: 16px; right: 16px; bottom: 16px; z-index: 2147482000;
    display: flex; align-items: center; gap: 14px;
    background: var(--green); color: #fff; padding: 13px 16px;
    border-radius: 14px; box-shadow: 0 10px 30px rgba(10,40,15,.28);
    animation: rise .3s ease;
  }
  .banner .txt { flex: 1; font-size: 14.5px; }
  .banner .txt b { font-weight: 800; }
  .banner .go {
    padding: 9px 15px; font-size: 14px; font-weight: 700; white-space: nowrap;
    background: #fff; color: var(--green); border: 0; border-radius: 9px; cursor: pointer;
  }
  .banner .x { background: none; border: 0; color: #fff; font-size: 19px; opacity: .75; cursor: pointer; padding: 0 3px; }

  @media (max-width: 560px) {
    .overlay { padding: 0; align-items: flex-end; }
    .card { max-width: none; border-radius: 18px 18px 0 0; max-height: 90vh; }
    .head { border-radius: 18px 18px 0 0; }
    .nps .scale { flex-wrap: wrap; }
    .nps .scale button { flex: 0 0 calc(100%/6 - 6px); }
    .banner { left: 10px; right: 10px; bottom: 10px; }
    .banner .txt { font-size: 13.5px; }
  }
  @media (prefers-reduced-motion: reduce) { * { animation: none !important; transition: none !important; } }
  `;

  /* ---------- 6. ÁLLAPOT ------------------------------------ */
  var state = { answers: {}, step: 0, source: 'popup', started: false, open: false };
  var root, shadow, host, bannerEl;

  function mountHost() {
    if (host) return;
    host = document.createElement('div');
    host.id = 'ff-survey-host';
    document.body.appendChild(host);
    shadow = host.attachShadow({ mode: 'open' });
    var s = document.createElement('style');
    s.textContent = CSS;
    shadow.appendChild(s);
    root = document.createElement('div');
    shadow.appendChild(root);
  }

  /* ---------- 7. MEGJELENÍTÉS ------------------------------- */
  function openSurvey(source) {
    if (state.open) return;
    mountHost();
    state = { answers: {}, step: 0, source: source || 'popup', started: false, open: true };
    track('survey_view', { survey_source: state.source });
    render();
    document.addEventListener('keydown', onEsc);
  }

  function onEsc(e) { if (e.key === 'Escape') closeSurvey('esc'); }

  function closeSurvey(reason) {
    if (!state.open) return;
    state.open = false;
    root.innerHTML = '';
    document.removeEventListener('keydown', onEsc);
    if (reason !== 'complete') {
      setFlag('dismissed', CFG.dismissDays);
      track('survey_dismiss', { survey_source: state.source, survey_step: state.step });
    }
  }

  var totalSteps = function () { return QUESTIONS.length + (CFG.askEmail ? 1 : 0); };

  function render() {
    var inline = state.source === 'thankyou' || state.source === 'inline';
    var isEmail = state.step === QUESTIONS.length;
    var q = QUESTIONS[state.step];
    var pct = Math.round((state.step / totalSteps()) * 100);

    var html = '' +
      '<div class="' + (inline ? 'inline-wrap' : 'overlay') + '" part="wrap">' +
        '<div class="card ' + (inline ? 'card--inline' : '') + '">' +
          (inline ? '' : '<button class="close" aria-label="Bezárás">&times;</button>') +
          (state.step === 0 ? heroHtml() : '') +
          '<div class="head">' +
            '<h2>Oszd meg a véleményed! 😊</h2>' +
            '<p>' + (state.step === 0
              ? 'Töltsd ki a rövid kérdőívet, és ajándékba adunk egy ' +
                (CFG.coupon.enabled ? '10% kedvezménykupont!' : 'köszönetet!')
              : 'Segíts nekünk jobbá válni!') + '</p>' +
            '<div class="bar"><i style="width:' + pct + '%"></i></div>' +
            '<div class="meta"><span>' + (state.step + 1) + ' / ' + totalSteps() + '</span>' +
            '<span>≈ 1 perc a kitöltés</span></div>' +
          '</div>' +
          '<div class="body">' + (isEmail ? emailStep() : questionStep(q)) + '</div>' +
        '</div>' +
      '</div>';

    root.innerHTML = html;
    bind(isEmail ? null : q);
  }

  function questionStep(q) {
    var h = '<div class="' + (q.type === 'nps' ? 'nps' : '') + '">' +
            '<div class="q">' + q.title + '</div>' +
            (q.hint ? '<div class="hint">' + q.hint + '</div>' : '');

    if (q.type === 'scale' || q.type === 'nps') {
      var min = q.type === 'nps' ? 0 : q.min;
      var max = q.type === 'nps' ? 10 : q.max;
      h += '<div class="scale">';
      for (var i = min; i <= max; i++) h += '<button type="button" data-val="' + i + '" aria-pressed="false">' + i + '</button>';
      h += '</div><div class="ends"><span>' + q.minLabel + '</span><span>' + q.maxLabel + '</span></div>';
    }

    if (q.type === 'choice' || q.type === 'multi') {
      h += '<div class="opts">';
      q.options.forEach(function (o) {
        h += '<button type="button" data-val="' + o + '" aria-pressed="false">' + o + '</button>';
      });
      h += '</div>';
    }

    if (q.type === 'text') {
      h += '<div class="field"><textarea placeholder="' + (q.placeholder || '') + '"></textarea></div>';
    }

    var needsBtn = q.type === 'multi' || q.type === 'text';
    h += '<div class="actions">';
    if (needsBtn) h += '<button class="btn" data-next>' + (state.step === QUESTIONS.length - 1 && !CFG.askEmail ? 'Küldés' : 'Tovább') + '</button>';
    if (q.optional) h += '<button class="btn--ghost btn" data-skip>Kihagyom</button>';
    h += '</div></div>';
    return h;
  }

  function emailStep() {
    return '' +
      '<div class="q">Hova küldhetjük a kupont?</div>' +
      '<div class="hint">Nem kötelező – a kérdőív enélkül is elküldhető.</div>' +
      '<div class="field">' +
        '<label class="label" for="ffmail">E-mail cím</label>' +
        '<input id="ffmail" type="email" placeholder="pelda@email.hu" autocomplete="email">' +
      '</div>' +
      '<label class="consent">' +
        '<input type="checkbox" id="ffconsent">' +
        '<span>Hozzájárulok, hogy a FamilyFirst a megadott e-mail címre elküldje a kedvezménykupont. ' +
        'A hozzájárulás bármikor visszavonható. <a href="' + CFG.privacyUrl + '" target="_blank" rel="noopener">Adatkezelési tájékoztató</a></span>' +
      '</label>' +
      '<div class="actions">' +
        '<button class="btn" data-finish>Küldés</button>' +
        '<button class="btn btn--ghost" data-skip-email>Kupont itt kérem</button>' +
      '</div>';
  }

  function bind(q) {
    var close = root.querySelector('.close');
    if (close) close.onclick = function () { closeSurvey('close'); };
    var ov = root.querySelector('.overlay');
    if (ov) ov.onclick = function (e) { if (e.target === ov) closeSurvey('backdrop'); };

    if (q) {
      var multi = q.type === 'multi';
      var picks = [];
      root.querySelectorAll('[data-val]').forEach(function (b) {
        b.onclick = function () {
          if (multi) {
            var v = b.dataset.val, i = picks.indexOf(v);
            if (i > -1) { picks.splice(i, 1); b.setAttribute('aria-pressed', 'false'); }
            else { picks.push(v); b.setAttribute('aria-pressed', 'true'); }
            state.answers[q.id] = picks.slice();
          } else {
            root.querySelectorAll('[data-val]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
            b.setAttribute('aria-pressed', 'true');
            state.answers[q.id] = isNaN(+b.dataset.val) ? b.dataset.val : +b.dataset.val;
            setTimeout(next, 180);
          }
        };
      });

      var ta = root.querySelector('textarea');
      var nx = root.querySelector('[data-next]');
      if (nx) nx.onclick = function () {
        if (ta) state.answers[q.id] = ta.value.trim();
        next();
      };
      var sk = root.querySelector('[data-skip]');
      if (sk) sk.onclick = next;
    }

    var fin = root.querySelector('[data-finish]');
    if (fin) fin.onclick = function () {
      var mail = root.querySelector('#ffmail').value.trim();
      var ok = root.querySelector('#ffconsent').checked;
      if (mail && !ok) { root.querySelector('#ffconsent').focus(); return; }
      if (mail && ok) { state.answers.email = mail; state.answers.email_consent = true; }
      finish();
    };
    var se = root.querySelector('[data-skip-email]');
    if (se) se.onclick = finish;
  }

  function next() {
    if (!state.started) {
      state.started = true;
      track('survey_start', { survey_source: state.source });
    }
    track('survey_step', { survey_source: state.source, step_number: state.step + 1, step_id: QUESTIONS[state.step] ? QUESTIONS[state.step].id : 'email' });
    state.step++;
    if (state.step >= totalSteps()) return finish();
    render();
  }

  function finish() {
    var payload = {
      survey_id: 'ff_csat_v1',
      source: state.source,
      answers: state.answers,
      url: location.pathname,
      submitted_at: new Date().toISOString()
    };

    track('survey_complete', {
      survey_source: state.source,
      rating: state.answers.satisfaction || null,
      nps: typeof state.answers.nps === 'number' ? state.answers.nps : null
    });

    if (CFG.endpoint) {
      // text/plain + no-cors: így nem indul CORS preflight, amit a Google
      // Apps Script nem kezel. A tartalom így is JSON-ként érkezik meg.
      fetch(CFG.endpoint, {
        method: 'POST',
        mode: CFG.endpointMode,
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      }).then(function () { track('survey_submit', { survey_source: state.source, status: 'ok' }); })
        .catch(function () { track('survey_submit', { survey_source: state.source, status: 'error' }); });
    } else {
      track('survey_submit', { survey_source: state.source, status: 'datalayer_only' });
      if (window.console) console.log('[FF Survey] válasz:', payload);
    }

    setFlag('completed', CFG.completeDays);
    if (bannerEl) { bannerEl.remove(); bannerEl = null; }
    renderThanks();
  }

  function renderThanks() {
    var c = CFG.coupon;
    var inline = state.source === 'thankyou' || state.source === 'inline';
    var html = '' +
      '<div class="' + (inline ? '' : 'overlay') + '">' +
        '<div class="card ' + (inline ? 'card--inline' : '') + '">' +
          (inline ? '' : '<button class="close" aria-label="Bezárás" style="color:#0F2A14;background:#F1F5F1">&times;</button>') +
          heroHtml() +
          '<div class="done" style="padding-top:14px">' +
            '<h3>Köszönjük a válaszaidat!</h3>' +
            (c.enabled
              ? '<p>' + c.label + '</p>' +
                '<div class="coupon">' +
                  '<div class="lab">Kuponkódod</div>' +
                  '<div class="code">' + c.code + '</div>' +
                  '<div class="val">A kupon ' + c.validDays + ' napig érvényes</div>' +
                  '<button class="copy" data-copy>Kód másolása</button>' +
                '</div>'
              : '<p>A véleményed segít, hogy jobbak legyünk.</p>') +
            (inline ? '' : '<div class="actions"><button class="btn" data-shop>Vissza a webáruházba</button></div>') +
          '</div>' +
        '</div>' +
      '</div>';
    root.innerHTML = html;

    if (c.enabled) track('survey_coupon_view', { coupon_code: c.code, survey_source: state.source });

    var cp = root.querySelector('[data-copy]');
    if (cp) cp.onclick = function () {
      var done = function () { cp.textContent = 'Másolva ✓'; track('survey_coupon_copy', { coupon_code: c.code }); };
      if (navigator.clipboard) navigator.clipboard.writeText(c.code).then(done).catch(done);
      else done();
    };
    var cl = root.querySelector('.close');
    if (cl) cl.onclick = function () { state.open = false; root.innerHTML = ''; };
    var sh = root.querySelector('[data-shop]');
    if (sh) sh.onclick = function () { state.open = false; root.innerHTML = ''; };
  }

  /* ---------- 8. ALSÓ SÁV ----------------------------------- */
  function showBanner() {
    if (bannerEl || !CFG.showBanner) return;
    mountHost();
    bannerEl = document.createElement('div');
    bannerEl.className = 'banner';
    bannerEl.innerHTML =
      '<div class="txt">🎁 Mondd el a véleményed és <b>szerezz 10% kedvezményt!</b></div>' +
      '<button class="go">Kitöltöm →</button>' +
      '<button class="x" aria-label="Bezárás">&times;</button>';
    shadow.appendChild(bannerEl);
    track('survey_view', { survey_source: 'banner' });
    bannerEl.querySelector('.go').onclick = function () { openSurvey('banner'); };
    bannerEl.querySelector('.x').onclick = function () {
      bannerEl.remove(); bannerEl = null;
      setFlag('dismissed', CFG.dismissDays);
    };
  }

  /* ---------- 9. TRIGGEREK ---------------------------------- */
  function blocked() {
    if (flagActive('completed') || flagActive('dismissed')) return true;
    return CFG.excludePaths.some(function (p) { return location.pathname.indexOf(p) === 0; });
  }

  function isThankYou() {
    return CFG.thankYouPaths.some(function (p) { return location.pathname.indexOf(p) > -1; });
  }

  function initTriggers() {
    // Rendelés utáni: mindig megjelenik, függetlenül a korlátozásoktól
    var target = document.querySelector(CFG.inlineTarget);
    if (target && (isThankYou() || target.dataset.force === 'true')) {
      mountHost();
      target.appendChild(host);
      state.source = 'thankyou';
      state.open = true;
      state.answers = {}; state.step = 0; state.started = false;
      track('survey_view', { survey_source: 'thankyou' });
      render();
      return;
    }
    if (isThankYou() && !target) { openSurvey('thankyou'); return; }

    if (blocked()) return;

    var fired = false;
    var fire = function (src) { if (!fired) { fired = true; openSurvey(src); } };

    setTimeout(function () { fire('popup_timer'); }, CFG.popupDelayMs);

    if (CFG.exitIntent && window.innerWidth > 1024) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) fire('popup_exit');
      });
    } else {
      window.addEventListener('scroll', function () {
        var p = (window.scrollY + window.innerHeight) / document.body.scrollHeight * 100;
        if (p >= CFG.mobileScrollPercent) fire('popup_scroll');
      }, { passive: true });
    }

    setTimeout(showBanner, 6000);
  }

  /* ---------- 10. NYILVÁNOS API ------------------------------ */
  window.FFSurvey = {
    open: function (src) { openSurvey(src || 'manual'); },
    banner: showBanner,
    reset: function () {
      store.removeItem('ff_survey_dismissed');
      store.removeItem('ff_survey_completed');
    },
    config: CFG
  };

  // Bármely elem megnyithatja: <a href="#" data-ff-survey>Oszd meg a véleményed!</a>
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ff-survey]');
    if (t) { e.preventDefault(); openSurvey('link'); }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTriggers);
  else initTriggers();
})();
